import { useTranslation } from "react-i18next";
import { FaDiscord } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
const iconSize = 32;
const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
    <div className="relative bg-[#030303] border-t-2 border-[rgb(84,87,245,0.2)] w-full mt-20 z-30">
    <div className="mainCont flex items-start justify-between gap-12 md:gap-8 flex-col md:flex-row py-5">
     <div>
      <a href="#"><img src="/images/logo.svg" alt="logo" className="w-[170px]" /></a>
      <div className="font-grotesk font-bold mt-5">{t('footer.rights', { year: new Date().getFullYear() })}</div>
     </div>

     <div className="flex flex-col md:items-end gap-7">
      <div className="flex items-center gap-5">
        {/* Github link */}
       <a href="https://github.com/paltalabs/" className="text-white transition hover:text-main">
          <FaGithub size={iconSize} />
        </a>

        {/* Linkedin Link */}
       <a href="https://www.linkedin.com/company/paltalabs/" className="text-white transition hover:text-main"><FaLinkedinIn size={iconSize} /></a>

       {/* Discord Link */}
       <a href="https://discord.gg/4F4pWFkkyZ" className="text-white transition hover:text-main"><FaDiscord size={iconSize} /></a>

       {/* Twitter Link */}
       <a href="https://twitter.com/paltalabs" className="text-white transition hover:text-main"><FaXTwitter size={iconSize} /></a>

       {/* Instagram Link */}
       <a href="https://www.instagram.com/paltalabs/" className="text-white transition hover:text-main"><FaInstagram size={iconSize} /></a>
      </div>

      <div className="flex gap-x-7 gap-5 flex-wrap whitespace-nowrap">
       <a href="#" className="font-grotesk text-white transition hover:text-main font-bold">Terms of Service</a>
       <a href="#" className="font-grotesk text-white transition hover:text-main font-bold">Privacy Policy</a>
       <a href="mailto:hello@paltalabs.io" className="font-grotesk text-white transition hover:text-main font-bold">hello@paltalabs.io</a>
      </div>
     </div>
    </div>
    </div>
    </>
  )
}

export default Footer